import { useLocation } from "@reach/router";
import React, { FunctionComponent } from "react";

interface VenueProps {
  virtual?: boolean;
}

const VenueInfo: FunctionComponent<VenueProps> = () => {
  const { pathname } = useLocation();
  const virtual = pathname.includes("virtual");

  return (
    <p className="venue-information" style={{ color: "#000" }}>
      Date: <span>10.17.2023</span>
      <br className="venue-information-break" />
      <span className="venue-information-space">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span>
      {virtual ? (
        <span>Virtual Event</span>
      ) : (
        <>
          Location: <span>Ronald Reagan Building, Washington, D.C.</span>
        </>
      )}
    </p>
  );
};

export default VenueInfo;
